import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SharedModule } from '@shared/shared.module';

import { environment } from '@env/environment';

const homeUrl = `${environment.apiBaseUrl}platform/homepage`;

const headers = new HttpHeaders({
  'x-no-notification': 'true'
});

@Injectable({
  providedIn: SharedModule
})
export class HomeService {

  constructor(private http: HttpClient) { }

  listUser(): Observable<any> {
    return this.http.get<any>(`${homeUrl}/user`);
  }

  listProfile(): Observable<any> {
    return this.http.get<any>(`${homeUrl}/profile`); // profile info end header data
  }

  listScorecards(): Observable<any> {
    return this.http.get<any>(`${homeUrl}/scorecards`);
  }

  listDashboards(): Observable<any> {
    return this.http.get<any>(`${homeUrl}/dashboards`);
  }

  listRepositories(): Observable<any> {
    return this.http.get<any>(`${homeUrl}/repositories`);
  }

  listAgileSpace(): Observable<any> {
    return this.http.get<any>(`${homeUrl}/agile-boards`);
  }

  listActions(): Observable<any> {
    return this.http.get<any>(`${homeUrl}/awaiting-actions`);
  }

  listLastActivities(): Observable<any> {
    return this.http.get<any>(`${homeUrl}/latest-activities`);
  }

}
